import React, { useState } from 'react'

import SixBoxesOtpInputField from '../OTPInput/SixBoxesOtpInputField'

interface props {
   label: string
   otpValue: string
   setOTPValue: (value: string) => void

   apiStatus?: number
   containerStyle?: string
   disabled?: boolean
   errorClassName?: string
   errorMsg?: string
   inputClassName?: string
   inputFocusClassName?: string
   labelStyles?: string
   numInputs?: number
   otpContainerStyles?: string
   onBlurFunction?: (event: React.SyntheticEvent) => void
   onResetError?: () => void
   hideSeparator?: boolean
}

const OTPBoxesField = React.memo((props: props) => {
   const {
      label,
      otpValue,
      setOTPValue,
      apiStatus,
      containerStyle,
      disabled,
      errorClassName,
      errorMsg,
      inputClassName,
      inputFocusClassName,
      labelStyles,
      numInputs,
      otpContainerStyles,
      onBlurFunction,
      onResetError
   } = props

   const [isFocus, setFocus] = useState(true)

   const onOTPFieldBlur = (event: React.SyntheticEvent): void => {
      if (onBlurFunction) {
         onBlurFunction(event)
      }

      setFocus(false)
   }

   const onChangeFunction = (value: string): void => {
      setOTPValue(value)
      setFocus(true)
      onResetError && onResetError()
   }

   return (
      <SixBoxesOtpInputField
         onChange={value => {
            onChangeFunction(value)
         }}
         otpValue={otpValue}
         isError={!!errorMsg}
         label={label}
         shouldAutoFocus={true}
         isDisabled={disabled}
         inputClassName={inputClassName}
         inputFocusClassName={inputFocusClassName}
         errorClassName={errorClassName}
         apiStatus={apiStatus}
         labelStyles={labelStyles}
         otpContainerStyles={otpContainerStyles}
         numInputs={numInputs}
         containerStyle={containerStyle}
         onBlur={onOTPFieldBlur}
         isFocus={isFocus}
         hideSeparator={props.hideSeparator}
      />
   )
})

export default OTPBoxesField
